"use client";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useToast } from "@/components/ui/use-toast";
import {
  OptionsContext,
  defaultSearchOptions,
} from "@/provider/options-provider";
import { useContext } from "react";
import { ExtraOptions } from "./extra-options";
import { SearchOptionCheckbox } from "./search-option-checkbox";

const switches = [
  {
    name: "forums",
    label: "Forums",
    description: "Search within Shareholder forums",
  },
  {
    name: "research",
    label: "Research",
    description: "Search within Research reports from Shareholder",
  },
  {
    name: "blogs",
    label: "Blogs",
    description: "Search within Blogs in Shareholder",
  },
  {
    name: "transcripts",
    label: "Transcripts",
    description: "Search within Transcripts",
  },
  {
    name: "articles",
    label: "Articles",
    description: "Search within Articles",
  },
];

export function Settings() {
  const { searchOptions, setSearchOptions } = useContext(OptionsContext);
  const { toast } = useToast();
  return (
    <div className="flex flex-col py-1">
      <div className="flex max-h-96 flex-col overflow-y-scroll px-1 md:max-h-full md:flex-row md:overflow-y-hidden">
        <div className="">
          {switches.map((sw) => (
            <div key={sw.name} className="">
              <SearchOptionCheckbox
                key={sw.name}
                id={sw.name}
                label={sw.label}
                description={sw.description}
              />
            </div>
          ))}
        </div>
        <Separator orientation="vertical" className="mx-2" />
        <ExtraOptions></ExtraOptions>
      </div>
      {/* <Separator className="my-1" /> */}
      <div className="mt-2 flex flex-row justify-between bg-slate-200 p-2 shadow-md">
        <AlertDialog>
          <AlertDialogTrigger asChild>
            <Button
              className="w-1/3 border-t border-gray-200 px-4 py-2 text-left text-sm text-gray-600 hover:bg-gray-100"
              type="button"
              variant={"outline"}
            >
              Save to profile
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>
                Save these settings to profile?
              </AlertDialogTitle>
              <AlertDialogDescription>
                The settings you save will be applied to all your searches the
                next time you log in.
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction
                onClick={async () => {
                  // Strip to known SearchOptions fields only to avoid exceeding
                  // the AWS Lambda 6MB payload limit when extra fields are present.
                  const {
                    dateRange,
                    dateRangeString,
                    switches,
                    maxSearchResults,
                    maxSummaryItems,
                    showGroupSummary,
                    maxFragments,
                    fragmentSize,
                    systemPrompt,
                    prompt,
                    summarizer_name,
                    order_by,
                    question,
                  } = searchOptions;
                  const payload = {
                    dateRange,
                    dateRangeString,
                    switches,
                    maxSearchResults,
                    maxSummaryItems,
                    showGroupSummary,
                    maxFragments,
                    fragmentSize,
                    systemPrompt,
                    prompt,
                    summarizer_name,
                    order_by,
                    question,
                  };
                  const response = await fetch("/api/user", {
                    method: "POST",
                    body: JSON.stringify(payload),
                  });

                  if (response.ok) {
                    toast({
                      title: "Settings saved",
                      description: "Your settings have been saved.",
                    });
                  } else {
                    toast({
                      title: "Error",
                      description: `Unable to save settings. Please try again later. Error: ${JSON.stringify(await response.json())}`,
                      variant: "destructive",
                    });
                  }
                }}
              >
                Continue
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
        <Button
          className="w-1/3 border-t border-gray-200 px-4 py-2 text-left text-sm text-white"
          type="button"
          onClick={() => {
            setSearchOptions(defaultSearchOptions);
          }}
          variant={"destructive"}
        >
          Reset to default
        </Button>
      </div>
    </div>
  );
}
